import React from "react";
import Banner from "./creator/banner";
import Editor from "./creator/editor";
import Latest from "./creator/latest";

const Creator = () => {
  return (
    <div>
      <Banner />
      <Editor />
      <Latest />
    </div>
  );
};

export default Creator;
